import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import revenueCategoriesReducer, { initialState } from '../reducers/revenueCategoriesReducer';

export const RevenueCategoriesContext = createContext();

const RevenueCategoriesProvider = ({ children }) => {
  const useRevenueCategoriesState = useReducer(revenueCategoriesReducer, initialState);

  return (
    <RevenueCategoriesContext.Provider value={[...useRevenueCategoriesState]}>
      <ContextDevTool
        context={RevenueCategoriesContext}
        id="RevenueCategoriesContext"
        displayName="Revenue CategoriesContext"
      />
      {children}
    </RevenueCategoriesContext.Provider>
  );
};

RevenueCategoriesProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default RevenueCategoriesProvider;
